import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../constants';
import type { MapperItemConfig } from './types';

export const getLogoMakerIdeasPath = ({ tag = '', tagType: type = '' }: MapperItemConfig) =>
    pathfinder(PATHFINDER.LOGO_MAKER_IDEAS_PAGE, { type, tag });
